var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { AlertDeliveryTypes } from '../../typings/enums';
import { ALERTS_DATA_INITIALIZE, ALERTS_DATA_RESET, ALERTS_DATA_SET_ERROR, ALERTS_DATA_SET_HAS_ACKNOWLEDGE_TERMS_CONDITIONS, ALERTS_DATA_SET_IS_LOADED, ALERTS_DATA_SET_IS_TERMS_CONSENT_DATA_LOADING, ALERTS_DATA_SET_SHOW_TERMS_CONSENT_BANNER, ALERTS_DATA_SET_TERMS_CONSENT_ERROR, ALERTS_DATA_UPDATE_ALERT } from '../actionTypes';
// eslint-disable-next-line import/no-cycle
import { initializeAlertsForm } from '../alertsForm/actions';
import { ALLOWED_DELIVERY_METHODS, PAY_LATER_PRODUCT_TYPE } from '../../const/alertsConfig';
import { getApprovedTransactionPreference, getCategoryId, getIsAlertOn, getPayLaterPreference, isApprovedTransactionsCreated, isPayLaterCreated, mapAttributesObjectToArray, mapDeliveryObjectToArray } from './actionsHelpers';
import { getAlertsRequest, updateConsent } from '../../services/alertService';
import responseCodes from '../../const/responseCodes';
import SyfStorage from '../../helpers/SyfStorage';
var getAlertsData = function (token, syfIdentifier, tokenId, apiHost, productType) { return __awaiter(void 0, void 0, void 0, function () {
    var getPreferenceResponse, smsConsent, alerts, hasApprovedTransactions, hasSetpayTransactions, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getAlertsRequest(token, syfIdentifier, tokenId, apiHost)];
            case 1:
                getPreferenceResponse = _a.sent();
                smsConsent = getPreferenceResponse.smsConsent;
                alerts = getPreferenceResponse.alerts;
                hasApprovedTransactions = isApprovedTransactionsCreated(alerts);
                hasSetpayTransactions = isPayLaterCreated(alerts) && PAY_LATER_PRODUCT_TYPE.includes(productType);
                if (hasApprovedTransactions) {
                    alerts = __spreadArray(__spreadArray([], alerts, true), [getApprovedTransactionPreference(alerts)], false);
                }
                if (hasSetpayTransactions) {
                    alerts = __spreadArray(__spreadArray([], alerts, true), [getPayLaterPreference(alerts)], false);
                }
                return [2 /*return*/, { alerts: alerts, smsConsent: smsConsent }];
            case 2:
                error_1 = _a.sent();
                if (error_1.message === "".concat(responseCodes.BAD_REQUEST) ||
                    error_1.message === "".concat(responseCodes.UNPROCESSABLE_ENTITY)) {
                    throw error_1;
                }
                throw new Error("".concat(responseCodes.INTERNAL_SERVER_ERROR));
            case 3: return [2 /*return*/];
        }
    });
}); };
export var initializeAlertData = function (payload) {
    return {
        type: ALERTS_DATA_INITIALIZE,
        payload: payload
    };
};
export var setAlertDataError = function (error) {
    return {
        type: ALERTS_DATA_SET_ERROR,
        payload: {
            error: error
        }
    };
};
export var setAlertDataisLoaded = function (isLoaded) {
    return {
        type: ALERTS_DATA_SET_IS_LOADED,
        payload: {
            isLoaded: isLoaded
        }
    };
};
export var setAlertsDataHasAcknowledgeTermsCondition = function (hasAcknowledgeTermsConditions) {
    return {
        type: ALERTS_DATA_SET_HAS_ACKNOWLEDGE_TERMS_CONDITIONS,
        payload: {
            hasAcknowledgeTermsConditions: hasAcknowledgeTermsConditions
        }
    };
};
export var setAlertsDataForTermsConentBanner = function (showTermsConsentBanner) {
    return {
        type: ALERTS_DATA_SET_SHOW_TERMS_CONSENT_BANNER,
        payload: {
            showTermsConsentBanner: showTermsConsentBanner
        }
    };
};
export var setAlertsDataTermsConsentError = function (termsConsentError) {
    return {
        type: ALERTS_DATA_SET_TERMS_CONSENT_ERROR,
        payload: {
            termsConsentError: termsConsentError
        }
    };
};
export var setAlertsDataIsTermsConsentLoading = function (isTermsConsentDataLoading) {
    return {
        type: ALERTS_DATA_SET_IS_TERMS_CONSENT_DATA_LOADING,
        payload: {
            isTermsConsentDataLoading: isTermsConsentDataLoading
        }
    };
};
export var resetAlertsData = function () {
    return {
        type: ALERTS_DATA_RESET
    };
};
export var updateAlertDataReducer = function (id, formAttributes, formDeliveryMethods) {
    return function (dispatch, getState) {
        var currentAlertData = getState().alertsData.byId[id];
        var updatedAttributes = currentAlertData.attributes.map(function (attr) {
            var _a;
            return __assign(__assign({}, attr), { value: (_a = formAttributes[attr.key]) === null || _a === void 0 ? void 0 : _a.value });
        });
        var updatedDeliveryMethods = currentAlertData.allDeliveryMethods.map(function (delMethod) {
            var _a;
            return __assign(__assign({}, delMethod), { enrolled: (_a = formDeliveryMethods[delMethod.key]) === null || _a === void 0 ? void 0 : _a.enrolled });
        });
        dispatch({
            type: ALERTS_DATA_UPDATE_ALERT,
            payload: {
                id: id,
                attributes: updatedAttributes,
                allDeliveryMethods: updatedDeliveryMethods,
                isAlertOn: getIsAlertOn(updatedDeliveryMethods)
            }
        });
    };
};
export var getAllAlerts = function () {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, token, syfIdentifier_1, _b, apiHost, accountsInfo, productType, correlationId, preferenceDataWithConsent, alerts, smsConsent, _c, allIds, byId_1, hasAcknowledgeTermsConditions, isTextEnrolled, error_2;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    _a = getState().authorizationReducer, token = _a.token, syfIdentifier_1 = _a.syfIdentifier;
                    _b = getState().appConfig, apiHost = _b.apiHost, accountsInfo = _b.accountsInfo;
                    productType = ((_e = (_d = accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo.find(function (_a) {
                        var accountId = _a.accountId;
                        return accountId === syfIdentifier_1;
                    })) === null || _d === void 0 ? void 0 : _d.product) === null || _e === void 0 ? void 0 : _e.type) || '';
                    correlationId = SyfStorage.getCorrelationId();
                    return [4 /*yield*/, getAlertsData(token, syfIdentifier_1, correlationId, apiHost, productType)];
                case 1:
                    preferenceDataWithConsent = _f.sent();
                    alerts = preferenceDataWithConsent.alerts, smsConsent = preferenceDataWithConsent.smsConsent;
                    dispatch(setAlertsDataHasAcknowledgeTermsCondition(smsConsent));
                    alerts.forEach(function (alert) {
                        var id = alert.id, delivery = alert.delivery, attributes = alert.attributes;
                        var categoryId = getCategoryId(id);
                        var formDelivery = {};
                        var filteredPrefDelivery = {};
                        ALLOWED_DELIVERY_METHODS.forEach(function (key) {
                            var _a;
                            filteredPrefDelivery[key] = delivery[key];
                            formDelivery[key] = {
                                enrolled: (_a = delivery[key]) === null || _a === void 0 ? void 0 : _a.enrolled
                            };
                        });
                        var deliveryMethodsArray = mapDeliveryObjectToArray(filteredPrefDelivery);
                        var attributesArray = mapAttributesObjectToArray(attributes);
                        var isAlertOn = getIsAlertOn(deliveryMethodsArray);
                        dispatch(initializeAlertsForm(id, formDelivery, attributes));
                        dispatch(initializeAlertData({
                            id: id,
                            categoryId: categoryId,
                            attributes: attributesArray,
                            allDeliveryMethods: deliveryMethodsArray,
                            isAlertOn: isAlertOn
                        }));
                    });
                    dispatch(setAlertDataisLoaded(true));
                    _c = getState().alertsData, allIds = _c.allIds, byId_1 = _c.byId, hasAcknowledgeTermsConditions = _c.hasAcknowledgeTermsConditions;
                    isTextEnrolled = allIds.some(function (alertId) {
                        return byId_1[alertId].allDeliveryMethods.some(function (deliveryMethod) {
                            return (deliveryMethod === null || deliveryMethod === void 0 ? void 0 : deliveryMethod.key) === AlertDeliveryTypes.Text &&
                                (deliveryMethod === null || deliveryMethod === void 0 ? void 0 : deliveryMethod.enrolled);
                        });
                    });
                    dispatch(setAlertsDataForTermsConentBanner(isTextEnrolled && !hasAcknowledgeTermsConditions));
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _f.sent();
                    dispatch(setAlertDataError(Number.isNaN(error_2.message)
                        ? "".concat(responseCodes.INTERNAL_SERVER_ERROR)
                        : error_2.message));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var updateTermsConsent = function () {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, token, syfIdentifier, apiHost, correlationId, statusCode, updateConsentRequest, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getState().authorizationReducer, token = _a.token, syfIdentifier = _a.syfIdentifier;
                    apiHost = getState().appConfig.apiHost;
                    correlationId = SyfStorage.getCorrelationId();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    dispatch(setAlertsDataIsTermsConsentLoading(true));
                    return [4 /*yield*/, updateConsent(token, syfIdentifier, correlationId, apiHost)];
                case 2:
                    updateConsentRequest = _b.sent();
                    statusCode = updateConsentRequest.status;
                    if (statusCode !== 202) {
                        dispatch(setAlertsDataTermsConsentError("".concat(statusCode)));
                    }
                    else {
                        dispatch(setAlertsDataHasAcknowledgeTermsCondition(true));
                        dispatch(setAlertsDataForTermsConentBanner(false));
                    }
                    dispatch(setAlertsDataIsTermsConsentLoading(false));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    if (statusCode !== 202) {
                        // set api error for update consent
                        dispatch(setAlertsDataTermsConsentError("".concat(statusCode)));
                        dispatch(setAlertsDataIsTermsConsentLoading(false));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
